import { QueryHookOptions } from '@apollo/client';
import { useApolloClient, useQuery } from '@ts-gql/apollo';
import { OperationData, OperationVariables, gql } from '@ts-gql/tag';
import React from 'react';

export const GET_USER_QUERY = gql`
  query GetUser($cloudId: String!) {
    getUser(cloudId: $cloudId) {
      cloudId
      fullName
      email
      active
      workflowRole
      administrator
      licensed
      roleName
      partner
      manager
    }
  }
` as import('../../__generated__/ts-gql/GetUser').type;

export type GetUserQueryVariables = OperationVariables<typeof GET_USER_QUERY>;
export type GetUserQueryResult = OperationData<typeof GET_USER_QUERY>;
export type GetUserQueryItem = NonNullable<GetUserQueryResult['getUser']>;

export const useGetUser = (
  options: QueryHookOptions<GetUserQueryResult, GetUserQueryVariables>
) => {
  const variables = options.variables as GetUserQueryVariables;

  const res = useQuery(GET_USER_QUERY, {
    context: { service: 'users' },
    variables,
    ...options,
  });

  return React.useMemo(() => ({ ...res, data: res.data?.getUser }), [res]);
};

export const useGetUserAsync = () => {
  const apolloClient = useApolloClient();

  return React.useCallback(
    async (variables: GetUserQueryVariables) => {
      const options = {
        query: GET_USER_QUERY,
        context: { service: 'users' },
        variables,
      };

      const res = await apolloClient.query(options);

      return {
        ...res,
        data: res.data?.getUser,
      };
    },
    [apolloClient]
  );
};
